import { ChevronRightOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useSideBar } from "./hooks/useSideBar";

function Sidebar({
  drawerWidth,
  isSideBarOpen,
  setIsSideBarOpen,
  isLargeScreen,
}) {
  const {
    active,
    handleLogout,
    handleLogoutClick,
    fullName,
    logoutDialogOpen,
    navItems,
    primary,
    backgroundColor,
    dark,
    secondaryDark,
    user,
    navigate,
    setActive,
    handleClose,
    handleModeToggle,
  } = useSideBar();

  const drawerContent = (
    <Box component="nav">
      {isSideBarOpen && (
        <Drawer
          open={isSideBarOpen}
          onClose={() => setIsSideBarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: primary,
              backgroundColor: backgroundColor,
              boxSizing: "border-box",
              borderWidth: isLargeScreen ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box mx={2} mt={2}>
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                color="textPrimary"
              >
                <Typography variant="span" color="primary">
                  {fullName}
                </Typography>
              </Typography>

              <Typography
                variant="subtitle2"
                color="textSecondary"
                gutterBottom
              >
                {user?.email}
              </Typography>
              <Typography
                variant="subtitle2"
                color={secondaryDark}
                gutterBottom
              >
                {user?.organisation?.name}
              </Typography>
            </Box>
            <List>
              {navItems.map(({ text, path, icon }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  );
                }

                if (path === "mode") {
                  return (
                    <ListItem key={text} disablePadding>
                      <ListItemButton
                        onClick={handleModeToggle}
                        sx={{
                          backgroundColor: "transparent",
                          color: dark,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            ml: "2rem",
                            color: dark,
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    </ListItem>
                  );
                }

                const lcText = path.toLowerCase();
                return (
                  <ListItem key={text} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        navigate(`${lcText}`);
                        setActive(lcText);
                      }}
                      sx={{
                        backgroundColor:
                          active === lcText ? primary : "transparent",
                        color: active === lcText ? backgroundColor : dark,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color: active === lcText ? backgroundColor : dark,
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <ListItemText primary={text} />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
              <ListItem disablePadding>
                <ListItemButton
                  onClick={handleLogoutClick}
                  sx={{ backgroundColor: "transparent", color: dark }}
                >
                  <ListItemIcon sx={{ ml: "2rem", color: dark }}>
                    <LogoutOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
      )}
      <Dialog open={logoutDialogOpen} onClose={handleClose}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to log out?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleLogout} color="error" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  return !isLargeScreen && isSideBarOpen ? (
    <ClickAwayListener onClickAway={() => setIsSideBarOpen(false)}>
      {drawerContent}
    </ClickAwayListener>
  ) : (
    drawerContent
  );
}

export default Sidebar;
